import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { invalidateReportsCache } from "@/lib/react-query/invalidateReportsCache";

export type ManualBatchItem = {
  pet_application_id: string | null;
  pet_application_plan_id: string | null;
  due_date: string;
  owner_id: string;
  pet_id: string;
  owner_name: string | null;
  pet_name: string | null;
  item_name: string | null;
  preferred_phone: string | null;
  owner_whatsapp_wa_id: string | null;
  owner_whatsapp_user_id: string | null;
  owner_whatsapp_parent_user_id: string | null;
  owner_whatsapp_username: string | null;
  death_date: string | null;
  whatsapp_opt_out: boolean;
};

export type ManualBatchItemResult = {
  pet_application_id: string | null;
  pet_application_plan_id: string | null;
  due_date: string;
  status: "sent" | "skipped" | "failed";
  reason?: string;
};

export type ManualBatchResult = {
  success: boolean;
  processed: number;
  dispatched: number;
  skipped: number;
  failed: number;
  details: ManualBatchItemResult[];
};

export function useSendWhatsAppApplicationRemindersManual() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: {
      clinicId: string;
      items: ManualBatchItem[];
    }): Promise<ManualBatchResult> => {
      const { data, error } = await supabase.functions.invoke<ManualBatchResult>(
        "send-whatsapp-application-reminders-manual",
        { body: { clinicId: input.clinicId, items: input.items } },
      );
      if (error) throw error;
      if (!data) throw new Error("Resposta vazia da função.");
      return data;
    },
    onSuccess: (_, variables) => {
      queryClient.removeQueries({ queryKey: ["application-operations", variables.clinicId] });
      queryClient.removeQueries({ queryKey: ["application-analytics", variables.clinicId] });
      invalidateReportsCache(queryClient);
    },
  });
}
